import { getCustomerUuid, useCart, useCustomerAutoshipSubscriptions, usePageLayout } from '@libs/common-next';
import { buildAddSubscriptionPayload } from '@libs/shared-ui';

import { useProduct } from '@/entities/product';
import type { FormFields } from '@/entities/purchase-form';

export const useNormalizeAutoshipSubscriptionData = () => {
    const { cart } = useCart();
    const { product } = useProduct();
    const { autoshipData } = useCustomerAutoshipSubscriptions();
    const nextSubscriptionOrderId = autoshipData?.data?.nextSubscriptionOrderId;
    const { user } = usePageLayout();
    const customerUuid = getCustomerUuid(user);

    return (formData: FormFields) =>
        buildAddSubscriptionPayload({
            customerUuid,
            sku: product?.sku,
            basketId: cart?.basketId,
            nextSubscriptionOrderId,
            form: formData,
        });
};
